import { Link } from "react-router-dom";
import type { Article } from "../../mocks/articles";

type Props = {
  article: Article;
  rank?: number;
  showImage?: boolean;
  className?: string;
};

export function ArticleCard({ article, rank, showImage = true, className = "" }: Props) {
  return (
    <article className={`group ${className}`}>
      <Link to={`/article/${article.slug}`} className="block">
        {showImage && (
          <div className="relative overflow-hidden rounded-lg bg-background-100">
            <img
              src={article.image}
              alt={article.imageAlt}
              title={`${article.title} - 今日瓜报`}
              className="aspect-[16/10] w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            {rank !== undefined && (
              <span className="absolute left-0 top-0 flex h-9 w-9 items-center justify-center bg-primary-500 font-serif text-base font-black text-background-50">
                {rank}
              </span>
            )}
          </div>
        )}
        <div className="mt-3">
          <div className="flex items-center gap-2 text-xs">
            <span className="font-medium text-primary-700">{article.kicker}</span>
            <span className="text-background-300">/</span>
            <span className="text-foreground-500">{article.tag}</span>
          </div>
          <h3 className="mt-2 font-serif text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
            {article.title}
          </h3>
          <p className="mt-2 hidden text-sm leading-relaxed text-foreground-600 sm:block">{article.excerpt}</p>
          <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-user-3-line" aria-hidden="true"></i>
              {article.author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line" aria-hidden="true"></i>
              {article.readMin}分钟
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
              {article.heat}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}

export function MiniArticleRow({ article }: { article: Article }) {
  return (
    <article className="group flex gap-4">
      <Link to={`/article/${article.slug}`} className="block w-24 shrink-0 overflow-hidden rounded-md bg-background-100 md:w-28">
        <img
          src={article.image}
          alt={article.imageAlt}
          title={`${article.title} - 今日瓜报`}
          className="aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="min-w-0">
        <span className="text-xs text-primary-700">{article.kicker}</span>
        <Link to={`/article/${article.slug}`}>
          <h4 className="mt-1 font-serif text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[15px]">
            {article.title}
          </h4>
        </Link>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
          <span>{article.date.slice(5).replace("-", "/")}</span>
          <span className="text-background-300">·</span>
          <span>{article.readMin}分钟</span>
        </div>
      </div>
    </article>
  );
}